import {
  BIRTHDAY, CALENDAR, CALL, CARD, CART, CHECK, CLOSE, COINS, CONTACT, DATE,
  DELETE, DOCUMENT, DRAG_DROP, EDIT, HOTEL, INFO, LOCATION, LOGOUT, MORE, PERSON,
  PEOPLES, PEOPLES_LINE, PHONE, PLUS, PROFILE, QUESTION, SEE, SEETING, STAR, UPLOAD
} from './../constants/icons'


export const setIcon = icon => {

  if (icon === "birthday") {
    return BIRTHDAY;
  } else if (icon === "calendar") {
    return CALENDAR;
  } else if (icon === "call") {
    return CALL;
  } else if (icon === "card") {
    return CARD;
  } else if (icon === "cart") {
    return CART;
  } else if (icon === "check") {
    return CHECK;
  } else if (icon === "close") {
    return CLOSE;
  } else if (icon === "coins") {
    return COINS;
  } else if (icon === "contact") {
    return CONTACT;
  } else if (icon === "date") {
    return DATE;
  } else if (icon === "delete") {
    return DELETE;
  } else if (icon === "document") {
    return DOCUMENT;
  } else if (icon === "drag_drop") {
    return DRAG_DROP;
  } else if (icon === "edit") {
    return EDIT;
  } else if (icon === "hotel") {
    return HOTEL;
  } else if (icon === "info") {
    return INFO;
  } else if (icon === "location") {
    return LOCATION;
  } else if (icon === "logout") {
    return LOGOUT;
  } else if (icon === "more") {
    return MORE;
  } else if (icon === "person") {
    return PERSON;
  } else if (icon === "peoples") {
    return PEOPLES;
  } else if (icon === "peoples_line") {
    return PEOPLES_LINE;
  } else if (icon === "phone") {
    return PHONE;
  } else if (icon === "plus") {
    return PLUS;
  } else if (icon === "profile") {
    return PROFILE;
  } else if (icon === "question") {
    return QUESTION;
  } else if (icon === "see") {
    return SEE;
  } else if (icon === "setting") {
    return SEETING;
  } else if (icon === "star") {
    return STAR;
  } else if (icon === "upload") {
    return UPLOAD;
  } else {
    return ''
  }
}


